import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_BOOLEAN_ICON, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Modal } from "../../theme/Component/Modal";
import { toast } from "react-toastify";
import { _AddCrossReference, _AddProductToMarketPlace, _ForProduct, _InventoryCatalog, _Product, _ProductVariant } from "../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../theme/Component/usePaginator";
import { SelectProductLine } from "../../theme/Component/SelectProductLine";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { SelectProductTypeConstants } from "./SelectProductTypeConstants";
import { SelectorUmeasurement } from "../../bpm/config/Componentes/SelectorUmeasurement";
import { ProductTaxsCatalogForAddedValue } from "./ProductTaxes/ProductTaxsCatalogForAddedValue";
import { ProductTaxsCatalogForHoldingValue } from "./ProductTaxes/ProductTaxsCatalogForHoldingValue";
import { BasicButton } from "../../theme/Component/BasicButton";
import { InputMoney } from "../../theme/Input/InputMoney";
import { MeasurementUnitCodeEditor } from "../../erp/MeasurementUnitCode/MeasurementUnitCode.editor";
import { ProductLocationCatalog } from "./ProductLocationCatalog";
import { ProductVariant } from "./ProductVariant";
import { TRUE } from "sass";
import { PrintJson } from "../../theme/Component/PrintJson";
import { FileInput } from "../../theme/Component/FileInput";
import { SelectProductEditor } from "../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { FileService } from "../../../core/services/FileService";
import useModal, { MODAL_LG } from "../../theme/Component/hooks/useModal";
import { ProductCost } from "../../Factoty&Production/ProductionOrderProcees/ProductCost/ProductCost";
import { SelectArticleClassCodeTree } from "../../contabilidad/catalogo-bienes/SelectArticleClassCodeTree";
import { ProductPhoto } from "./ProductPhoto";
import { MarketPlaceCategoryEditor } from "./MarketPlace/MarketPlaceCategoryEditor";
import { MarketPlaceEditor } from "./MarketPlace/MarketPlaceEditor";
import { ProductCrossReference } from "./ProductCrossReference";
import { SelectStoreEditor } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { InputDate } from "../../theme/Input/InputDate";

interface Props {
    isModal?: boolean;
    onChange?: Function;
    filterType?: number;
}

export const Product = ({ isModal, onChange, filterType }: Props) => {

    // const product = useDataBean(_InventoryCatalog);
    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_Product);
    const paginador = usePaginator();
    const addmarket = useDataBean(_AddProductToMarketPlace);
    const forprod = useDataBean(_ForProduct);
    const [documentCost, setDocumentCost] = useState<any>(null);
    const [active, setActive] = useState<any>(null);
    const cross = useDataBean(_AddCrossReference);
    const fileService = new FileService();
    const [table, setTable] = useState<any>({ name: 'Variantes y Tallas', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [Habilitar, setHabilitar] = useState<any>(null)
    const [productCode, setProductCode] = useState<string>(null)
    const [reference, setReference] = useState<string>(null)
    const [IDProduct, setIDProduct] = useState<string>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cost, setcost] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [Addplace, setAddplace] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [Addref, setAddref] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [Ref, setRef] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalImpuestos, setModalImpuestos] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalRetenciones, setModalRetenciones] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [configurar, setConfigurar] = useState<any>({ name: 'Configurar/Consultar Configuraciones de Ubicación', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [habilitartalla, setHabilitartalla] = useState<any>({ name: 'Habilitar Variantes/Tallas de Producto Terminado', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [impotar, setImportar] = useState<any>({ name: 'Importar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [line, setLine] = useState<number>(null);
    const [regexStr, setRegexStr] = useState<string>("");
    const [registers, setRegisters] = useState<number>(15);
    const [type, setType] = useState<number>(filterType ?? null);
    const [galeri, setGaleri] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const modalHisoty = useModal(`Historial de ${bean.Description}`, MODAL_LG)

    useEffect(() => {
        getLista()
    }, [paginador.page, registers])

    const filtrar = () => {
        getLista()
    }

    const getLista = () => {
        instance.getInventoryCatalog(line, regexStr ?? null, type, productCode, reference, parseFloat(IDProduct), paginador.page, registers).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (registers ?? 15));
                    paginador.setRegiPerPage(registers)
                    const updatedList = resp.List.map((element: any) => {

                        element.DataBeanProperties.URL = element.DataBeanProperties.Media ? `<a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" className="pointer" target='_blank'>Descargar Documento</a>` : "N/A";
                        if (
                            element?.DataBeanProperties?.MeasurementUnitCode &&
                            element?.DataBeanProperties?.MeasurementUnitName
                        ) {
                            return {
                                ...element,
                                DataBeanProperties: {
                                    ...element.DataBeanProperties,
                                    UnitType: `${element.DataBeanProperties.MeasurementUnitCode} - ${element.DataBeanProperties.MeasurementUnitName}`,
                                },
                            };
                        }
                        return element; // Devuelve el elemento sin cambios si no cumple con las condiciones
                    });

                    setLista(updatedList);
                }
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const editaItem = () => {
        update().then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        deleteItemVoid(bean.IDLine).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDProduct', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre del Producto', property: 'Description', visible: true },
        { title: 'Tipo de Producto', property: 'TypeName', visible: true },
        { title: 'Código', property: 'ProductCode', visible: true },
        { title: 'Tipo de Bien/Servicio', property: 'ArticleClassCodeName', visible: true },
        { title: 'Referencia', property: 'Reference', visible: true, mask: MASK_NUMBER },
        { title: 'SKU', property: 'StockKeepingUnit', visible: true },
        { title: 'Url', property: 'Url', visible: true },
        { title: 'Tipo', property: 'Type', visible: true },
        { title: 'Producto para Traslado a Consumo/Materia Prima', property: 'ProductConsumptionName', visible: true },
        { title: 'Grupo de Activos', property: 'ProductLineName', visible: true },
        { title: 'Estandard de Producción', property: 'Recipe', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Unidad de Media (Facturador UBL)', property: 'UBLMeasurementUnitName', visible: true },
        { title: 'Valor de Venta', property: 'SalesValue', visible: true, mask: MASK_MONEY },
        { title: 'Cantidades Negativas', property: 'AllowNegatives', visible: true },
        { title: 'Utilizar Costo de Producto', property: 'UseProductCost', visible: true },
        { title: 'Costo de Producto', property: 'ProductCost', visible: true },
        { title: 'Impuestos Incluidos', property: 'AddedTaxIncluded', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Cantidad Mínima en Stock', property: 'MinQuantityUnits', visible: true },
        { title: 'Cantidad Máxima en Stock', property: 'MaxQuantityUnits', visible: true },
        { title: 'Stock Promedio de Seguridad', property: 'SecurityStockUnits', visible: true },
        { title: 'Demanda Diaria Promedio', property: 'AverageDailyDemandUnits', visible: true },
        { title: 'Tiempo de Entrega Promedio en Días', property: 'AverageDeliverTimeInDays', visible: true },
        { title: 'Hoja de Vida/Especificaciones del Producto', property: 'URL', visible: true },
    ]


    const variantes = () => {
        setTable({ ...table, "view": true, "name": "Consultar / Configurar" });
    }

    const addProductToMarketPlace = () => {

        addmarket.instance.addProductToMarketPlace(bean.IDProduct, addmarket.bean.IDMarketPlace, addmarket.bean.IDMarketPlaceCategory).then(
            (resp: any) => {
                getLista();
                setAddplace({ ...Addplace, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const addCrossReferenceToProduct = () => {

        cross.instance.addCrossReferenceToProduct(bean.IDProduct, cross.bean.IDProductParent, cross.bean.Name, cross.bean.Description).then(
            (resp: any) => {
                getLista();
                setAddref({ ...Addref, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const getProductCostForProduct = () => {
        if (!forprod.bean.Date) {
            toast.warning("Debe seleccionar una Fecha.");
            return;
        }
        forprod.instance.getProductCostForProduct(forprod.bean.IDProduct, forprod.bean.IDStore, forprod.bean.Date, forprod.bean.ValidateQuantities).then(
            (resp: any) => {
                console.log(resp.TotalCost)
                // setcost({ ...cost, "view": false });
                setActive(true)
                setDocumentCost(resp)
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {

        setBean({
            IDEmployee: _single.getAccountID(),
            Recipe: false,
            AddedTaxIncluded: false,
            Type: filterType ?? null,

        });

        setHabilitar(null);
        setModal({ ...modal, "view": true, "name": "Agregar Producto de Inventario" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Configurar/Consultar Configuraciones de Ubicación', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setConfigurar({ ...configurar, "view": true }) } },
            { titulo: 'Habilitar Variantes/Tallas de Producto Terminado', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setHabilitartalla({ ...habilitartalla, "view": true }) } },
            { titulo: 'Galería de Fotos del Producto', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setGaleri({ ...galeri, "view": true }) } },
            { titulo: 'Agregar Productos a MarketPlace', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setAddplace({ ...Addplace, "view": true }) } },
            { titulo: 'Agregar Referencias Relacionadas', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setAddref({ ...Addref, "view": true }) } },
            { titulo: 'Referencias Relacionadas', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setRef({ ...Ref, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Producto de Inventario" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Producto de Inventario` }) } },
            { titulo: 'Histórico de Solicitudes', icono: 'ri-file-history-line', visible: true, evento: () => { modalHisoty.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        console.log(bean)
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }


    const importProductCatalog = () => {
        setImportar({ ...impotar, "view": true })
    }
    const vercost = () => {
        forprod.setBean({

        });
        setcost({ ...cost, "view": true })
    }
    const updatePlantilla = () => {
        instance.importProductCatalog(bean.Media, bean.MediaContext, null).then(
            (rta: any) => {
                setLista(rta)
                setImportar({ ...impotar, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const validateForm = () => {
        const requiredFields = [
            "Description", "Type", "IDLine",
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "" || Number.isNaN(bean[field])) {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        console.log(missing)
        return missing.length;
    };

    const setRowBean = (obj: any) => {
        setBean(obj)
        if (onChange) {
            onChange(obj)
        }
    }

    return (


        <>
            <div className="row">
                <div className="col-md-12">
                    <Modal modal={configurar} updateModal={setConfigurar}>
                        <>
                            {/* <PrintJson json={bean.IDProduct} /> */}
                            <ProductLocationCatalog Product={bean.IDProduct} />
                        </>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={impotar} updateModal={setImportar} eventModal={updatePlantilla}>
                        <> <FileInput
                            Media={bean.Media}
                            MediaContext={bean.MediaContext}
                            directory="fabrica"
                            label="Cargar un archivo"
                            onCreate={({ MediaContext, Media }: any) => {
                                setBean({
                                    ...bean,
                                    Media: Media, MediaContext: MediaContext

                                });
                            }}

                        />
                            {/* <FileInput label="Importar Formato" Media="" MediaContext="" directory="supplier" onCreate={updatePlantilla} /> */}
                        </>
                    </Modal>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <Modal modal={habilitartalla} updateModal={setHabilitartalla}>
                        <>
                            {/* <PrintJson json={bean.IDProduct} /> */}
                            <ProductVariant Product={bean.IDProduct} />
                        </>
                    </Modal>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <Modal modal={galeri} updateModal={setGaleri}>
                        <>
                            {/* <PrintJson json={bean.IDProduct} /> */}
                            <ProductPhoto idProduct={bean.IDProduct} />
                        </>
                    </Modal>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <Modal modal={Addplace} updateModal={setAddplace} eventModal={addProductToMarketPlace}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <MarketPlaceEditor idSelector={addmarket.bean.IDMarketPlace} onChange={(e) => { addmarket.setBean({ ...addmarket.bean, "IDMarketPlace": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <MarketPlaceCategoryEditor idMarketPlace={addmarket.bean.IDMarketPlace} idSelector={addmarket.bean.IDMarketPlaceCategory} onChange={(e) => { addmarket.setBean({ ...addmarket.bean, "IDMarketPlaceCategory": e }) }} />
                                </div>
                                {/* <div className="col-md-12">
                                    <SelectProductEditor label="Producto" value={addmarket.bean.IDProduct} onChange={(e) => { addmarket.setBean({ ...addmarket.bean, "IDProduct": e.IDProduct }) }} />
                                </div> */}
                            </div>
                        </>
                    </Modal>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <Modal modal={Addref} updateModal={setAddref} eventModal={addCrossReferenceToProduct}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <SelectProductEditor label="Referencia Cruzada" value={cross.bean.IDProductParent} onChange={(e) => { cross.setBean({ ...cross.bean, "IDProductParent": e.IDProduct }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label>Nombre</label>
                                    <input type="text" name="Name" className="form-control" value={cross.bean.Name} onChange={cross.handleChange} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={cross.bean.Description} onChange={cross.handleChange} />
                                </div>
                            </div>
                        </>
                    </Modal>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <Modal modal={Ref} updateModal={setRef}>
                        <>
                            <div className="row">
                                <ProductCrossReference idProduct={bean.IDProduct} />
                            </div>
                        </>
                    </Modal>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">

                    {isModal ?
                        <div className="row">
                            <div className="col-md-6">
                                <SelectProductLine idSelector={line} onChange={setLine} label="Grupo de Productos de Inventario" />
                            </div>
                            <div className="col-md-6">
                                <SelectProductTypeConstants disable={filterType ? true : false} idSelector={type} onChange={setType} />
                            </div>
                            <div className="col-md-6">
                                <label>ID Producto</label>
                                <input type="text" className="form-control" value={IDProduct} onChange={(e) => { setIDProduct(e.target.value) }} onBlur={() => { getLista() }} />
                            </div>
                            <div className="col-md-6">
                                <label>Código de Producto</label>
                                <input type="text" className="form-control" value={productCode} onChange={(e) => { setProductCode(e.target.value) }} onBlur={() => { getLista() }} />
                            </div>
                            <div className="col-md-6">
                                <label>Referencia de Producto</label>
                                <input type="text" className="form-control" value={reference} onChange={(e) => { setReference(e.target.value) }} onBlur={() => { getLista() }} />
                            </div>
                            <div className="col-md-6">
                                <label>Buscar por Texto</label>
                                <input type="text" className="form-control" value={regexStr} onChange={(e) => { setRegexStr(e.target.value) }} onBlur={() => { getLista() }} />
                            </div>
                            <div className="col-md-4 mt-4">

                                <BasicButton icon="ri-align-justify" eventClick={filtrar}>Filtrar Tabla por Parametros</BasicButton>
                            </div>

                            <div className="col-md-12">
                                <BasicTable
                                    listButtons={listaBotones()}
                                    iconButtons={iconButtonsItem}
                                    head={head} body={lista}
                                    rowSet={setRowBean}
                                    pageTop={paginador.page}
                                    next={paginador.next}
                                    back={paginador.back}
                                    records={paginador}
                                    customRows={registers}
                                />
                            </div>
                        </div>
                        :
                        <BasicPage titulo="Productos de Inventario" >
                            <div className="row">
                                <div className="col-md-6">
                                    <SelectProductLine idSelector={line} onChange={setLine} label="Grupo de Productos de Inventario" />
                                </div>
                                <div className="col-md-6">
                                    <SelectProductTypeConstants idSelector={type} onChange={setType} />
                                </div>
                                {/* <div className="col-md-6">
                                    <SelectProductEditor label="Producto" value={IDProduct} onChange={(e) => { setIDProduct(e) }} />
                                </div> */}

                                <div className="col-md-6">
                                    <label>ID Producto</label>
                                    <input type="text" className="form-control" value={IDProduct} onChange={(e) => { setIDProduct(e.target.value) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Código de Producto</label>
                                    <input type="text" className="form-control" value={productCode} onChange={(e) => { setProductCode(e.target.value) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Referencia de Producto</label>
                                    <input type="text" className="form-control" value={reference} onChange={(e) => { setReference(e.target.value) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Buscar por Texto</label>
                                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setRegexStr(e.target.value) }} />
                                </div>
                                <div className="col-md-2 mt-4">
                                    <BasicButton icon="ri-align-justify" eventClick={filtrar}>Buscar</BasicButton>
                                </div>
                                <div className="col-md-2 mt-4">
                                    <BasicButton icon="ri-send-plane-fill" eventClick={importProductCatalog}>Importar Archivo</BasicButton>
                                </div>
                                <div className="col-md-3 mt-4">
                                    <BasicButton icon="ri-align-justify" eventClick={filtrar}>Filtrar Tabla por Parametros</BasicButton>
                                </div>
                                <div className="col-md-4 mt-4">
                                    <BasicButton icon="ri-money-dollar-circle-line" eventClick={vercost}>Costo de Producto</BasicButton>
                                </div>
                                <div className="col-md-12">
                                    <BasicTable
                                        listButtons={listaBotones()}
                                        iconButtons={iconButtonsItem}
                                        head={head} body={lista}
                                        rowSet={setRowBean}
                                        pageTop={paginador.page}
                                        next={paginador.next}
                                        back={paginador.back}
                                        records={paginador}
                                        customRows={registers}
                                    />
                                </div>
                            </div>
                        </BasicPage>
                    }
                </div>

                <div className="col-md-12">
                    <Modal modal={modalHisoty.modal} updateModal={modalHisoty.setModal} >
                        <div className="row">
                            <div className="col">
                                <ProductCost idProduct={bean.IDProduct} isModal />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={cost} updateModal={setcost} eventModal={getProductCostForProduct}>
                        <div className="row">
                            <div className="col-md-12">
                                <label >Producto</label>
                                <SelectProductEditor renderValue={forprod.bean.ProductName} value={forprod.bean.IDProduct} onChange={(e) => { forprod.setBean({ ...forprod.bean, "IDProduct": e.IDProduct }) }} />
                            </div>
                            <div className="col-md-12">
                                <SelectStoreEditor label='Almacén/Bodega' idSelector={forprod.bean.IDStore} onChange={(e: any) => { forprod.setBean({ ...forprod.bean, "IDStore": e.IDStore }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate notDate label="Fecha de Corte" name="Date" value={forprod.bean.Date} setDate={(e) => { forprod.setBean({ ...forprod.bean, "Date": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Validar Valores de Contabilidad" estado={forprod.bean.ValidateQuantities} eventChange={(e) => { forprod.setBean({ ...forprod.bean, "ValidateQuantities": e }) }}></BasicSwitch>
                            </div>
                            {active && <>
                                <div className="col-md-12 mt-3">

                                    <table className="table table-bordered">

                                        <thead>
                                            <tr>
                                                <th>Costo de Producto</th>
                                                <th>Cantidad Total</th>
                                                <th>Costo Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    {documentCost?.ProductCost}
                                                </td>
                                                <td>
                                                    {documentCost?.TotalQuantity}
                                                </td>
                                                <td>
                                                    {documentCost?.TotalCost}
                                                </td>

                                            </tr>

                                        </tbody>

                                    </table>

                                </div>
                            </>}
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">


                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObjec}>
                        <strong>Eliminar Informacion de {bean.IDLine} - {bean.Description}</strong>
                    </ModalConfirm>
                </div>

                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={validateData}>
                        <div className="row">
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`}>Descripción</label>
                                <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('Type') ? 'has-error' : ''}`}>Tipo de Producto</label>
                                <SelectProductTypeConstants disable={filterType ? true : false} idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} label=" " />
                            </div>
                            <div className="col-md-6">

                                <SelectArticleClassCodeTree onChange={(e: any) => { setBean({ ...bean, "IDLnArticleClassCode": e.IDLn }) }} IDLn={bean.IDLnArticleClassCode} label='Tipo de Bien/Servicio' />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDLine') ? 'has-error' : ''}`}>Grupo de Productos</label>
                                <SelectProductLine disable={bean.IDProduct} idSelector={bean.IDLine} onChange={(e) => { setBean({ ...bean, "IDLine": e }) }} label=" " />
                            </div>
                            <div className="col-md-6">
                                <SelectProductEditor label="Producto para Traslado a Consumo/Materia Prima" renderValue={bean.ProductConsumptionName} value={bean.IDProductConsumption} onChange={(e) => { setBean({ ...bean, "IDProductConsumption": e.IDProduct }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" className="form-control" name="ProductCode" value={bean.ProductCode} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Referencia</label>
                                <input type="text" className="form-control" name="Reference" value={bean.Reference} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>SKU</label>
                                <input type="text" className="form-control" name="StockKeepingUnit" value={bean.StockKeepingUnit} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <MeasurementUnitCodeEditor label='Unidad de Medida (Facturador UBL)' idSelector={bean.IDMeasurementUnitCode} onChange={(e: any) => { setBean({ ...bean, "IDMeasurementUnitCode": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectorUmeasurement titulo='Unidad de Medida' idSelector={bean.IDMeasurementUnit} onChange={(e: any) => { setBean({ ...bean, "IDMeasurementUnit": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectProductTypeConstants idSelector={bean.Type} onChange={(e: any) => { setBean({ ...bean, "Type": e }) }} />
                            </div><div className="col-md-6">
                                <label>Url </label>
                                <input type="text" className="form-control" name="Url" value={bean.Url} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">

                                <BasicSwitch label='Estandard de Producción' estado={bean.Recipe} eventChange={(e) => { setBean({ ...bean, "Recipe": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputMoney _value={bean.SalesValue} onChange={(e) => { setBean({ ...bean, "SalesValue": e }) }} _label="Valor de Venta" />
                            </div>
                            <div className="col-md-6">

                                <BasicSwitch label='Impuestos Incluidos' estado={bean.AddedTaxIncluded} eventChange={(e) => { setBean({ ...bean, "AddedTaxIncluded": e }) }} />
                            </div>

                            <div className="col-md-6">

                                <BasicSwitch label='Cantidades Negativas' estado={bean.AllowNegatives} eventChange={(e) => { setBean({ ...bean, "AllowNegatives": e }) }} />
                            </div>
                            <div className="col-md-6">

                                <BasicSwitch label='Utilizar Costo Estándar ?*' estado={bean.UseProductCost} eventChange={(e) => { setBean({ ...bean, "UseProductCost": e }) }} />
                            </div>

                            <div className="col-md-6">
                                <label>Costo Estándar</label>
                                <input type="text" className="form-control" name="ProductCost" value={bean.ProductCost} onChange={handleChange} />
                            </div>

                            <div className="col-md-6">
                                <label>Cantidad Mínima en Stock</label>
                                <input type="number" className="form-control" value={bean.MinQuantityUnits} onChange={(e) => { setBean({ ...bean, MinQuantityUnits: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Cantidad Máxima en Stock</label>
                                <input type="number" className="form-control" value={bean.MaxQuantityUnits} onChange={(e) => { setBean({ ...bean, MaxQuantityUnits: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Stock Promedio de Seguridad</label>
                                <input type="number" className="form-control" value={bean.SecurityStockUnits} onChange={(e) => { setBean({ ...bean, SecurityStockUnits: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Demanda Diaria Promedio</label>
                                <input type="number" className="form-control" value={bean.AverageDailyDemandUnits} onChange={(e) => { setBean({ ...bean, AverageDailyDemandUnits: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Tiempo de Entrega Promedio en Días</label>
                                <input type="number" className="form-control" value={bean.AverageDeliverTimeInDays} onChange={(e) => { setBean({ ...bean, AverageDeliverTimeInDays: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <FileInput
                                    label="Hoja de Vida/Especificaciones del Producto"
                                    onCreate={(e) => { setBean({ ...bean, Media: e.Media, MediaContext: e.MediaContext }) }}
                                    Media={bean.Media}
                                    MediaContext={bean.MediaContext}
                                />
                            </div>
                        </div>

                        {bean.IDProduct &&
                            <div className="row mt-3">
                                <div className="col-md-6 d-flex justify-content-center">
                                    <BasicButton eventClick={() => { setModalImpuestos({ ...modalImpuestos, "view": true, "name": `Definir Impuestos de Valor Agregado` }) }} icon="ri-file-copy-2-line" children={"Definir Impuestos de Valor Agregado"} />
                                </div>
                                <div className="col-md-6 d-flex justify-content-center">
                                    <BasicButton eventClick={() => { setModalRetenciones({ ...modalRetenciones, "view": true, "name": `Definir Retenciones a Título de Impuesto` }) }} icon="ri-bill-line" children={"Definir Retenciones a Título de Impuesto"} />
                                </div>

                            </div>
                        }

                        <div className="col-md-12">
                            <Modal modal={modalImpuestos} updateModal={setModalImpuestos}>
                                <ProductTaxsCatalogForAddedValue _idProduct={bean.IDProduct} />
                            </Modal>
                        </div>

                        <div className="col-md-12">
                            <Modal modal={modalRetenciones} updateModal={setModalRetenciones} >
                                <ProductTaxsCatalogForHoldingValue _idProduct={bean.IDProduct} />
                            </Modal>
                        </div>
                    </Modal>
                </div>
            </div >
        </>
    )
}



